<template>
    <div class="navigation_bar" :class="typeClass" v-if="isShow">
        <div class="navigation_left">
            <slot name="left">
                <div class="navigation_back">
                    <YD-image :src="img_src" @click.native.stop="backPage()"></YD-image>
                </div>
            </slot>
        </div>
        <div class="navigation_title">
            <slot name="title"><span class="navigation_text">{{title}}</span></slot>
        </div>
        <div class="navigation_action">
            <slot><slot name="action"></slot></slot>
        </div>
    </div>
</template>

<script>
import tools from '@/common/tools';
export default {
    name:"NavigationBar",
    data(){
        return {
            isShow: false
        }
    },
    props:{
        type:{
            type: String,
            default: 'light',
            validator: val=>['light', 'dark'].includes(val)
        },
        title:{
            type: String
        }
    },
    created(){
        if(tools.isWxMiniApp()){
            this.isShow = false;
        }else{
            this.isShow = true;
        }
    },
    computed:{
        typeClass(){
            return this.type == 'light' ? 'is-light' : 'is-dark';
        },
        img_src(){
            var src = '';
            switch (this.type){
                case 'light':
                    src = 'icon/icon_nav_back';
                    break;
                case 'dark':
                    src = 'icon/icon_nav_back_white';
                    break;
            }
            return src;
        }
    },
    methods:{
        backPage(){
            if('backPage' in this.$listeners){
                this.$emit('backPage');
            }else{
                this.$navigation.back();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.navigation_bar{
    width: 100%;
    height: 88px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    &.is-light{
        background: #FFFFFF;
        .navigation_title{
            color: #1B1C1E;
        }
    }
    &.is-dark{
        background: #1B1C1E;
        .navigation_title{
            color: #FFFFFF;
        }
    }
    .navigation_left{
        height: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 40px;
        .navigation_back{
            width: 48px;
            height: 48px;
            margin-left: -6px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .navigation_title{
        font-size: 34px;
        font-weight: 500;
        display: flex;
        align-items: center;
        >span.navigation_text{
            max-width: 350px;
            display: inline-block;
            @include ellipsis;
        }
    }
    .navigation_action{
        height: 100%;
        width: auto;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 40px;
    }
}
</style>